import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { UntypedFormControl } from '@angular/forms';
import { ContentService, Project } from '../../../cms/content.service';

@Component({
    selector: 'app-services',
    templateUrl: './services.component.html',
    styleUrls: ['./services.component.scss'],
    standalone: false
})
export class ServicesComponent implements OnInit {

  projects: Array<Project & { coverUrl: string }> = [];
  public page: number = 1;
  public tamanoTabl = new UntypedFormControl('5');

  constructor(
    private viewportScroller: ViewportScroller,
    private contentService: ContentService
  ) {}

  public onClick(elementId: string): void { 
      this.viewportScroller.scrollToAnchor(elementId);
  }

  ngOnInit(): void {
    this.contentService.getProjects().subscribe(response => {
      this.projects = response.data.map(project => ({
        ...project,
        description: this.normalizeDescription(project.description),
        coverUrl: this.contentService.assetUrl(project.cover) || 'assets/img/proyecto-1.jpg'
      }));
    });
  }
  
  openLink(link: string | null): void {
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  }

  private ensureParagraphs(source: string): string {
    const trimmed = (source || '').trim();
    if (!trimmed) return '';
    if (/<(p|div|ul|ol|h[1-6]|blockquote|table|figure|section|article|br)\b/i.test(trimmed)) {
      return trimmed;
    }
    return trimmed
      .split(/\n+/)
      .map(line => line.trim())
      .filter(Boolean)
      .map(line => `<p>${line}</p>`)
      .join('');
  }

  private normalizeDescription(html: string): string {
    const documentFragment = new DOMParser().parseFromString(this.ensureParagraphs(html), 'text/html');

    documentFragment.body
      .querySelectorAll('script, iframe, object, embed, link, meta, style')
      .forEach(element => element.remove());

    documentFragment.body.querySelectorAll<HTMLElement>('*').forEach(element => {
      Array.from(element.attributes).forEach(attribute => {
        const name = attribute.name.toLowerCase();
        const value = attribute.value.trim().toLowerCase();

        if (name.startsWith('on') || ((name === 'href' || name === 'src') && value.startsWith('javascript:'))) {
          element.removeAttribute(attribute.name);
        }
      });
    });

    documentFragment.body.querySelectorAll<HTMLElement>('[style]').forEach(element => {
      element.style.removeProperty('color');
      element.style.removeProperty('background-color');

      if (!element.getAttribute('style')?.trim()) {
        element.removeAttribute('style');
      }
    });

    return documentFragment.body.innerHTML;
  }

}
